const INPUT_RANGE = {
    height: {
        min: 1,
        max: 300,
    },
    weight: {
        min: 1,
        max: 200,
    },
    pregnantWeek: {
        min: 1,
        max: 40,
    },
};

export { INPUT_RANGE as I };
